import { Eye, EyeOff } from 'lucide-react'

import { Button, Tooltip } from '~/components/component-library'
import { useAuth } from '~/context/AuthProvider'
import { useAuthUser } from '~/hooks/useAuthUser'
import { usePrivacyModeStore } from '~/store/privacyModeStore'
import { cn } from '~/utils/tailwind-utils'

export const PrivacyModeToggle = ({ className }: { className?: string }) => {
  const isPrivacyModeOn = usePrivacyModeStore((state) => state.isPrivacyModeOn)
  const toggle = usePrivacyModeStore((state) => state.toggle)
  const { user: authUser } = useAuthUser()
  const {
    onboarding: { isOnboarding },
  } = useAuth()
  const label = isPrivacyModeOn
    ? 'Show balances and addresses'
    : 'Hide balances and addresses'

  // Privacy mode is for members of a workspace; public pages and the workspace-creation
  // wizard have nothing to mask.
  if (!authUser || isOnboarding) return null

  return (
    <div className={cn('shrink-0', className)}>
      <Tooltip content={label}>
        <Button
          aria-label={label}
          variant="tertiary"
          size="small"
          onClick={toggle}
          eventName="toggledPrivacyMode"
          eventProperties={{ enabled: !isPrivacyModeOn }}
          prefix={
            // 20px box matching the sidebar's avatar trigger; the wrapper escapes
            // Button's `[&>svg]:size-4` so the 16px glyph sets its own size.
            <div className="flex size-5 items-center justify-center">
              {isPrivacyModeOn ? <Eye size={16} /> : <EyeOff size={16} />}
            </div>
          }
        />
      </Tooltip>
    </div>
  )
}
